import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

function loadView(view) {
  return import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}

export default new Router({
  base : '',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('About')
    },
    {
      path: '/intro',
      name: 'intro',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('Intro')
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('Login')
    },
    {
      path: '/signup',
      name: 'signup',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('SignUp')
    },
    {
      path: '/wallet_main',
      name: 'wallet_main',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('WalletMain')
    },
    {
      path: '/receive_main',
      name: 'receive_main',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('ReceiveMain')
    },
    {
      path: '/send_main',
      name: 'send_main',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('SendMain') 
    },
    {
      path: '/send_result',
      name: 'send_result',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('SendResult')
    },
    {
      path: '/password',
      name: 'password',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('Password')
    },
    {
      path: '/convert_main',
      name: 'convert_main',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('ConvertMain')
    },
    {
      path: '/wallet_list',
      name: 'wallet_list',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('WalletList')
    },
    {
      path: '/notice_list',
      name: 'notice_list',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('NoticeList') 
    },
    {
      path: '/news_list',
      name: 'news_list',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('NewsList')
    },
    {
      path: '/push_list',
      name: 'push_list',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('PushList')
    },
    {
      path: '/faq_list',
      name: 'faq_list',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('FAQList')
    },   
    {
      path: '/find_passwd',
      name: 'find_passwd',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('FindPasswd') 
    },
    {
      path: '/charge_passwd',
      name: 'charge_passwd',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('ChargePassword')
    }, 
    {
      path: '/setting_locak_screen',
      name: 'setting_locak_screen',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('SettingLockScreen') 
    },  
    {
      path: '/setting_push',
      name: 'setting_push',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('SettingPush')
    }, 
    {
      path: '/setting_currency',
      name: 'setting_currency',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('SettingCurrency')
    },   
    {
      path: '/test_page',
      name: 'test_page',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('TestPage')
    },  
    {
      path: '/qrcode_reader',
      name: 'qrcode_reader',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => loadView('QRCodePopUp')
    },  
  ]
})
